module.exports = __webpack_public_path__ + "u2f_usb.591cc98f43cbb68c10ddf345cb2d164e.png";